import { render } from "./editSort.vue?vue&type=template&id=0ae93f94&scoped=true"
import script from "./editSort.vue?vue&type=script&lang=js"
export * from "./editSort.vue?vue&type=script&lang=js"

import "./editSort.vue?vue&type=style&index=0&id=0ae93f94&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ae93f94"],['__file',"src/views/brandProduct/components/editSort.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ae93f94"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ae93f94', __exports__)) {
    console.log('reload')
    api.reload('0ae93f94', __exports__)
  }
  
  module.hot.accept("./editSort.vue?vue&type=template&id=0ae93f94&scoped=true", () => {
    console.log('re-render')
    api.rerender('0ae93f94', render)
  })

}


export default __exports__